import { PulseLoader } from "react-spinners";
import $ from "jquery";

export const logoutFunction = (status) => {
    if (status === 401) {
        window.location.pathname = "/sessionexpired";
    }
    if (status === 403) {
        window.location.pathname = "/usernotfound";
    }
}

export const Loader = ({ isAppLoader }) => {

    return (
      <>{isAppLoader &&
          <div className='loader'>
            <div className="spinner_overlay">
              <div className="loader">
                <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
              </div>
            </div>
          </div>}
      </>
    );
  };

export function CheckPasswordValid(isPasswordProtected, newPasswordValue, confirmPasswordValue){
    let passwordCheck = false;
    if(isPasswordProtected == false){
      passwordCheck = true;
    } else {
      let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;
      const newPasswordCheck = regex.test(newPasswordValue);
      const confirmPasswordCheck = regex.test(confirmPasswordValue);
      if(newPasswordValue == ""){
        $('.newdoc-newpassword').addClass('password-input-valid');
        $('.newPasswordErrorText').text('Please fill the new password');
      } else if (newPasswordCheck == false){
        $('.newdoc-newpassword').addClass('password-input-valid');
        $('.newPasswordErrorText').text("Your new password must be 8 to 15 characters long and include at least one uppercase letter, one lowercase letter, one digit, and one special character from the set '@.#$!%*?&'");
      } else if (newPasswordCheck == true){
        $('.newdoc-newpassword').removeClass('password-input-valid');
        $('.newPasswordErrorText').text('');
      }

      if(confirmPasswordValue == ""){
        $('.newdoc-confirmpassword').addClass('password-input-valid');
        $('.confirmPasswordErrorText').text('Please fill the confirm password');
      } else if (confirmPasswordCheck == false){
        $('.newdoc-confirmpassword').addClass('password-input-valid');
        $('.confirmPasswordErrorText').text("Your confirm password must be 8 to 15 characters long and include at least one uppercase letter, one lowercase letter, one digit, and one special character from the set '@.#$!%*?&'");
      } else if (confirmPasswordCheck == true){
        $('.newdoc-confirmpassword').removeClass('password-input-valid');
        $('.confirmPasswordErrorText').text('');
      }
 
      if (newPasswordCheck == true && confirmPasswordCheck == true && newPasswordValue == confirmPasswordValue) {
        passwordCheck = true;
        $('.newPasswordErrorText').text('');
        $('.confirmPasswordErrorText').text('');
        $('.newdoc-newpassword').removeClass('password-input-valid');
        $('.newdoc-confirmpassword').removeClass('password-input-valid');
      } else {
        passwordCheck = false;
        if (newPasswordCheck == true && confirmPasswordCheck == true){
          $('.newdoc-newpassword').addClass('password-input-valid');
          $('.newdoc-confirmpassword').addClass('password-input-valid');
          $('.confirmPasswordErrorText').text('New password and confirm password must be same');
        }
      }
    }
    return passwordCheck;
}